import { QueryInput } from "@/services/entity-instance.service";
import { getPyloUserList } from "@/services/pylo-user.service";
import { useInfiniteQuery } from "@tanstack/react-query";

export const usePyloUsers = (query?: QueryInput[], per_page?: number) => {
  return useInfiniteQuery({
    queryKey: ["pylo-users-list", query, per_page],
    queryFn: ({ pageParam }) => {
      return getPyloUserList({ query, cursor: pageParam, per_page });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.pagination.has_more_pages ? lastPage.pagination.current_page + 1 : undefined;
    },
  });
};
